export { default } from './RibbonStarOne'
